import { useRef, useState } from 'react';
import { supabase } from '../lib/supabase';

const ACCEPTED = 'image/jpeg,image/jpg,image/png,image/webp,application/pdf';
const MAX_BYTES = 5 * 1024 * 1024;

const labelStyle = {
  display: 'block',
  fontSize: '0.82rem',
  fontWeight: '600',
  color: '#555',
  marginBottom: '0.3rem',
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
};

const PaymentProofUploadField = ({ userId, purchaseId, value, onChange, onUploadingChange }) => {
  const fileRef = useRef(null);
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState(null);

  const handleUpload = async (file) => {
    setError(null);
    if (file.size > MAX_BYTES) {
      setError('El archivo no puede superar 5 MB.');
      return;
    }
    if (!userId) {
      setError('Debes iniciar sesión para subir el comprobante.');
      return;
    }

    const safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_').slice(-80);
    const path = `${userId}/${purchaseId}/${Date.now()}_${safeName}`;

    setIsUploading(true);
    onUploadingChange?.(true);
    try {
      const { error: uploadErr } = await supabase.storage
        .from('payment_proofs')
        .upload(path, file, { cacheControl: '3600', upsert: false, contentType: file.type });
      if (uploadErr) {
        setError(`Error al subir el comprobante: ${uploadErr.message}`);
        return;
      }
      onChange({ path, filename: file.name });
    } catch (err) {
      setError(`Error inesperado: ${err.message}`);
    } finally {
      setIsUploading(false);
      onUploadingChange?.(false);
    }
  };

  return (
    <div style={{ marginBottom: '1rem' }}>
      <label style={labelStyle}>Comprobante de pago</label>
      <input
        ref={fileRef}
        type="file"
        accept={ACCEPTED}
        style={{ display: 'none' }}
        onChange={(e) => {
          const f = e.target.files?.[0];
          if (f) handleUpload(f);
          e.target.value = '';
        }}
      />
      <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
        <button
          type="button"
          onClick={() => fileRef.current?.click()}
          disabled={isUploading}
          style={{
            padding: '0.5rem 1rem',
            background: isUploading ? '#ddd' : '#2ca9e1',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontWeight: '600',
            cursor: isUploading ? 'wait' : 'pointer',
            fontSize: '0.9rem',
          }}
        >
          {isUploading ? 'Subiendo...' : value?.path ? 'Cambiar archivo' : 'Seleccionar archivo'}
        </button>
        {value?.filename && (
          <span style={{ fontSize: '0.85rem', color: '#28a745' }}>{value.filename}</span>
        )}
      </div>
      <p style={{ margin: '0.5rem 0 0', fontSize: '0.78rem', color: '#888' }}>
        Aceptamos JPG, PNG, WEBP o PDF (máx. 5 MB).
      </p>
      {error && <p style={{ margin: '0.4rem 0 0', color: '#dc3545', fontSize: '0.85rem' }}>{error}</p>}
    </div>
  );
};

export default PaymentProofUploadField;
